export default "/react/logoTwoPilot-9d66a9ce.png";